export default __webpack_public_path__ + "static/media/Theme1.4446c065.jpg";